import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'

import AreaRepository from '@/shared/http/repositories/configuration/area'
import RegionServiceRepository from '@/shared/http/repositories/configuration/regionservice'
import RegionServiceModel from '@/shared/models/configuration/regionservicemodel'
import RegionServiceForms from './regionservice-form'

import StateRepository from '@/shared/http/repositories/geo/state'
import CityRepository from '@/shared/http/repositories/geo/city'

export default {
  name: 'RegionService',
  mixins: [ActionsForm],
  data () {
    return {
      data: RegionServiceModel,
      form: RegionServiceForms
    }
  },
  components: {
    Cfg
  },
  mounted () {
    this.onLoadAllArea()
    this.onLoadAllState()
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      RegionServiceRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
      this.onLoadAllState()
    },
    onEdit (obj) {
      loading.push()
      this.onClear()
      // --> Set manual options
      this.data.id = obj.id
      this.data.status = obj.status
      this.form.areaID.value = obj.areaID
      this.form.name.value = obj.name
      this.form.description.value = obj.description

      if (obj.stateList && obj.stateList.length > 0) {
        this.form.stateList.options = []
        var states = obj.stateList
        for (var i in states) {
          var id = states[i]
          StateRepository.GetById(id)
            .then((response) => {
              var obj = response.data.data
              this.form.stateList.options.push({ 'text': obj.name, 'value': obj.id })
            })
            .catch((err) => {
              this.onException(err)
            })
        }
      }

      if (obj.cityList && obj.cityList.length > 0) {
        this.form.cityID.options = []
        var cities = obj.cityList
        for (var x in cities) {
          id = cities[x]
          CityRepository.GetById(id)
            .then((response) => {
              var obj = response.data.data
              if (obj) {
                this.form.cityList.options.push({ 'text': obj.name, 'value': obj.id })
              }
            })
            .catch((err) => {
              this.onException(err)
            })
        }
      }

      // --> Remove itens with delay
      var selected = obj.stateList
      if (selected) {
        var self = this
        setTimeout(function (e) {
          for (var x in selected) {
            var options = self.form.stateID.options
            for (var i in options) {
              if (options[i].value === selected[x]) {
                self.form.stateID.options.splice(i, 1)
                // options.splice(i, 1)
              }
            }
          }
        }, 500)
      }

      loading.pop()
    },
    onCreate () {
      loading.push()
      RegionServiceRepository.Create(this.setCityListDefaultNull(this.data))
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      RegionServiceRepository.Update(this.setCityListDefaultNull(this.data))
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      RegionServiceRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllArea () {
      loading.push()
      AreaRepository.GetAll()
        .then((response) => {
          this.form.areaID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllState () {
      loading.push()
      this.form.stateID.options = []
      StateRepository.GetAll()
        .then((response) => {
          this.form.stateID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllCity (id) {
      this.form.cityID.options = []
      if (id) {
        loading.push()
        CityRepository.GetAllByStateID(id)
          .then((response) => {
            this.form.cityID.options = this.onResultDropdown(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onChangeState () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllCity(self.form.stateID.value)
      }, 500)
    },
    onAddStates () {
      var selected = this.form.stateID.value
      var options = this.form.stateID.options
      if (selected) {
        for (var x in selected) {
          for (var i in options) {
            if (options[i].value === selected[x]) {
              this.form.stateList.options.push(options[i])
              this.form.stateID.options.splice(i, 1)
              //
              this.onLoadAllCity(selected)
            }
          }
        }
      }
    },
    onRemoveStates () {
      var selected = this.form.stateList.value
      var options = this.form.stateList.options
      if (selected) {
        for (var x in selected) {
          for (var i in options) {
            if (options[i].value === selected[x]) {
              this.form.stateID.options.push(options[i])
              this.form.stateList.options.splice(i, 1)
            }
          }
        }
      }
    },
    onAddCities () {
      var selected = this.form.cityID.value
      var options = this.form.cityID.options
      if (selected) {
        for (var x in selected) {
          for (var i in options) {
            if (options[i].value === selected[x]) {
              this.form.cityList.options.push(options[i])
              this.form.cityID.options.splice(i, 1)
            }
          }
        }
      }
    },
    onRemoveCities () {
      var selected = this.form.cityList.value
      var options = this.form.cityList.options
      if (selected) {
        for (var x in selected) {
          for (var i in options) {
            if (options[i].value === selected[x]) {
              this.form.cityID.options.push(options[i])
              this.form.cityList.options.splice(i, 1)
            }
          }
        }
      }
    },
    setCityListDefaultArray: function (obj) {
      if (obj.cityList == null) {
        obj.cityList = []
      }
      return obj
    },
    setCityListDefaultNull: function (data) {
      if (data.cityList.length === 0) {
        data.cityList = null
      }
      return data
    },
    setCityListEdit: function (cities) {
      if (cities) {
        var options = this.form.cityID.options
        if (options.length > 0) {
          clearInterval(this.polling)
          var selected = cities.split(';')
          if (selected) {
            for (var x in selected) {
              for (var i in options) {
                if (options[i].value === selected[x]) {
                  this.form.cityList.options.push(options[i])
                  this.form.cityID.options.splice(i, 1)
                }
              }
            }
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/regionservice/regionservice.js